module.exports = __webpack_public_path__ + "static/media/icon_cross.1f3625bd.svg";